/**
 * @file 再計算
 *
 */
'use strict';

/**
 * @classname BtnReCalculateView
 * @classdesc 再計算
 */
export default class BtnReCalculateView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('BtnReCalculateView.constructor');
		this._$e = $e;
		const $listItem = $e.closest('.list-item');
		this._productId = $listItem.attr('data-product-id');
		this._skuId = $listItem.attr('data-sku-id');
		this._$orderNum = $listItem.find('.order_num');
		$e.on('click', () => {this.onClick();});
	};


	/**
	 * クリックのコールバック
	 *
	 * @memberof BtnReCalculateView
	 * @return {undefined}
	 */
	onClick() {
		console.log('BtnReCalculateView.onClick');
		const orderNum = this._$orderNum.val();
		Cookies.set('order-num-change', 'true');
		console.log(`orderNum: ${orderNum}`);
		$('#product_id').val(this._productId);
		$('#sku_id').val(this._skuId);
		$('#order_num').val(orderNum);
		$('#form-cart-add').submit();
	}
}
